// Korean source keys are UI copy only. Never pass names, release data or server errors here.
const rows = [
  ['음성으로 참여', 'Join with audio', '语音加入', '音声で参加'],
  ['마이크만 사용', 'Use microphone only', '仅使用麦克风', 'マイクのみ使用'],
  ['이 기기에서는 다른 참여자의 공유 화면을 볼 수 있습니다. 내 화면 공유는 PC에서 시작하세요.', 'You can view shared screens on this device. Start sharing your own screen from a computer.', '此设备可以查看其他参与者共享的屏幕。请在电脑上共享自己的屏幕。', 'この端末では他の参加者の共有画面を表示できます。自分の画面共有はPCから開始してください。'],
  ['언어', 'Language', '语言', '言語'],
  ['화면 공유를 시작할 수 없습니다: {detail}', 'Could not start screen sharing: {detail}', '无法开始屏幕共享：{detail}', '画面共有を開始できません: {detail}'],
  ['카메라 또는 마이크를 찾을 수 없습니다. 장치가 연결되어 있는지 확인해주세요.', 'Camera or microphone not found. Check that your devices are connected.', '找不到摄像头或麦克风。请检查设备是否已连接。', 'カメラまたはマイクが見つかりません。機器が接続されているか確認してください。'],
  ['카메라와 마이크 접근 권한이 필요합니다. 브라우저 권한을 확인해주세요.', 'Camera and microphone access is required. Check your browser permissions.', '需要摄像头和麦克风访问权限。请检查浏览器权限。', 'カメラとマイクへのアクセス許可が必要です。ブラウザーの権限を確認してください。'],
  ['미디어 장치 접근 오류: {detail}', 'Media device access error: {detail}', '访问媒体设备时出错：{detail}', 'メディア機器へのアクセスエラー: {detail}'],
  ['카메라를 켤 수 없습니다: {detail}', 'Could not turn on the camera: {detail}', '无法开启摄像头：{detail}', 'カメラをオンにできません: {detail}'],
  ['앤츠미팅', 'AntsMeeting', 'AntsMeeting', 'AntsMeeting'],
  ['전체', 'All', '全部', 'すべて'],
  ['AI 애니메이션', 'AI animation', 'AI 动画', 'AIアニメーション'],
  ['AI 판타지 드라마', 'AI fantasy drama', 'AI 奇幻剧', 'AIファンタジードラマ'],
  ['AI 판타지', 'AI fantasy', 'AI 奇幻', 'AIファンタジー'],
  ['AI 액션 드라마', 'AI action drama', 'AI 动作剧', 'AIアクションドラマ'],
  ['AI 무협 드라마', 'AI martial arts drama', 'AI 武侠剧', 'AI武侠ドラマ'],
  ['AI 생존 드라마', 'AI survival drama', 'AI 生存剧', 'AIサバイバルドラマ'],
  ['AI SF', 'AI science fiction', 'AI 科幻', 'AI SF'],
  ['SF', 'Science fiction', '科幻', 'SF'],
  ['미스터리', 'Mystery', '悬疑', 'ミステリー'],
  ['드라마', 'Drama', '剧情', 'ドラマ'],
  ['판타지', 'Fantasy', '奇幻', 'ファンタジー'],
  ['스릴러', 'Thriller', '惊悚', 'スリラー'],
  ['애니메이션', 'Animation', '动画', 'アニメーション'],
  ['✦ 이번 주 추천작', '✦ This week’s picks', '✦ 本周推荐', '✦ 今週のおすすめ'],
  ['작품 정보', 'Work details', '作品信息', '作品情報'],
  ['작품 정보 닫기', 'Close work details', '关闭作品信息', '作品情報を閉じる'],
  ['YouTube에서 보기 ↗', 'Watch on YouTube ↗', '在 YouTube 上观看 ↗', 'YouTubeで見る ↗'],
  ['공개 예정', 'Coming soon', '即将公开', '近日公開'],
  ['작품명, 장르로 검색', 'Search by title or genre', '按作品名或类型搜索', '作品名・ジャンルで検索'],
  ['AI 작품 큐레이션', 'AI works curation', 'AI 作品精选', 'AI作品キュレーション'],
  ['에디터 추천과 지금 주목받는 작품을 한눈에 만나보세요.', 'Explore editor picks and works in the spotlight.', '一览编辑推荐和热门作品。', '編集者のおすすめと注目作品をチェック。'],
  ['☆ 당신을 위한 추천', '☆ Recommended for you', '☆ 为你推荐', '☆ あなたへのおすすめ'],
  ['앤츠캐스트가 고른 AI 창작물', 'AI creations selected by Ants Cast', 'Ants Cast 精选的 AI 创作', 'Ants Castが選ぶAI作品'],
  ['✦ PICK', '✦ PICK', '✦ 推荐', '✦ おすすめ'],
  ['★ 평점 {score}', '★ Rating {score}', '★ 评分 {score}', '★ 評価 {score}'],
  ['↗ 실시간 TOP 10', '↗ Live TOP 10', '↗ 实时 TOP 10', '↗ リアルタイム TOP 10'],
  ['작품 점수와 편집 순위를 반영합니다', 'Based on work scores and editorial order', '反映作品评分和编辑排序', '作品の評価と編集順位を反映'],
  ['전체 AI 작품', 'All AI works', '全部 AI 作品', 'すべてのAI作品'],
  ['AI로 만든 새로운 작품을 한곳에서 만나보세요.', 'Discover new AI-created works in one place.', '在这里发现 AI 创作的新作品。', 'AIによる新しい作品をまとめてチェック。'],
  ['영상 공개', 'Video available', '视频已公开', '動画公開中'],
  ['✦ 모든 작품은 AI로 제작된 창작물입니다. 실제 인물·사건과 관련이 없습니다.', '✦ All works are AI-created fiction, unrelated to real people or events.', '✦ 所有作品均为 AI 创作的虚构作品，与真实人物及事件无关。', '✦ すべてAIで制作された創作物であり、実在の人物・事件とは関係ありません。'],
  ['{author} 채널에서 공개한 작품입니다.', 'Published on the {author} channel.', '由 {author} 频道公开的作品。', '{author}チャンネルで公開された作品です。'],
  ['앤츠캐스트 AI 작품관에서 소개하는 창작물입니다. 정식 공개와 함께 전체 이야기를 만나보세요.', 'A creation featured in the Ants Cast AI gallery. Discover the full story when it is officially released.', 'Ants Cast AI 作品馆介绍的创作。正式公开后即可欣赏完整故事。', 'Ants Cast AI作品ギャラリーで紹介する創作物です。正式公開で物語の全編をお楽しみください。'],
  ['YouTube에서 작품 보기 ↗', 'Watch the work on YouTube ↗', '在 YouTube 上观看作品 ↗', 'YouTubeで作品を見る ↗'],
  ['참여자 ({count})', 'Participants ({count})', '参会者（{count}）', '参加者（{count}）'],
  ['호스트', 'Host', '主持人', 'ホスト'],
  ['나 (호스트)', 'You (Host)', '我（主持人）', '自分（ホスト）'],
  ['사용자 {id}', 'User {id}', '用户 {id}', 'ユーザー {id}'],
  ['빈 자리 {number}', 'Empty Slot {number}', '空位 {number}', '空き枠 {number}'],
  ['회의 닫기', 'Close meeting', '关闭会议', '会議を閉じる'],
  ['회의 나가기', 'Leave meeting', '离开会议', '会議から退出'],
  ['표시 인원 줄이기', 'Show fewer people', '减少显示人数', '表示人数を減らす'],
  ['표시 인원 늘리기', 'Show more people', '增加显示人数', '表示人数を増やす'],
  ['참여자 목록 열기', 'Open participant list', '打开参会者列表', '参加者一覧を開く'],
  ['참여자 목록 닫기', 'Close participant list', '关闭参会者列表', '参加者一覧を閉じる'],
  ['마이크 켜기', 'Unmute microphone', '开启麦克风', 'マイクをオン'],
  ['카메라 끄기', 'Turn camera off', '关闭摄像头', 'カメラをオフ'],
  ['카메라 켜기', 'Turn camera on', '开启摄像头', 'カメラをオン'],
  ['화면 공유 중지', 'Stop sharing screen', '停止共享屏幕', '画面共有を停止'],
  ['연결 중...', 'Connecting...', '正在连接...', '接続中...'],
  ['인증에 실패했습니다.', 'Authentication failed.', '身份验证失败。', '認証に失敗しました。'],
  ['링크가 만료되었거나 유효하지 않습니다.', 'The link has expired or is invalid.', '链接已过期或无效。', 'リンクの有効期限が切れているか、無効です。'],
  ['연결됨', 'Connected', '已连接', '接続済み'],
  ['연결 끊김', 'Disconnected', '连接已断开', '切断済み'],
  ['연결 오류', 'Connection error', '连接错误', '接続エラー'],
  ['참여 방법을 선택하세요', 'Choose how to join', '选择加入方式', '参加方法を選択'],
  ['화상 카메라', 'Video camera', '摄像头', 'ビデオカメラ'],
  ['카메라와 마이크 사용', 'Use camera and microphone', '使用摄像头和麦克风', 'カメラとマイクを使用'],
  ['화면과 오디오 공유', 'Share screen and audio', '共享屏幕和音频', '画面と音声を共有'],
  ['화상 채팅 -', 'Video meeting -', '视频会议 -', 'ビデオ会議 -'],
  ['{count}인 / 8인', '{count} / 8 people', '{count}人 / 8人', '{count}人 / 8人'],
  ['[{count}명]', '[{count} participants]', '[{count}人]', '[{count}人]'],
  ['언어 설정을 저장하지 못했습니다.', 'Could not save the language setting.', '无法保存语言设置。', '言語設定を保存できませんでした。'],
  ['AI 작품관', 'AI gallery', 'AI 作品馆', 'AI作品ギャラリー'],
  ['기능', 'Features', '功能', '機能'],
  ['활용', 'Use cases', '应用场景', '活用例'],
  ['사용 방법', 'How to use', '使用方法', '使い方'],
  ['다운로드', 'Download', '下载', 'ダウンロード'],
  ['회의 시작', 'Start a meeting', '开始会议', '会議を開始'],
  ['빠르게 시작하고,', 'Start quickly,', '快速开始，', 'すぐに始めて、'],
  ['더 명확하게 연결되는 미팅', 'connect more clearly', '更清晰地沟通', 'もっと明確につながる会議'],
  ['원격제어와 화상미팅을 하나로 담은 협업 솔루션', 'One collaboration solution for remote control and video meetings', '集远程控制与视频会议于一体的协作方案', '遠隔操作とビデオ会議を一つにしたコラボレーションツール'],
  ['이름과 코드만으로 즉시 연결하고,', 'Connect instantly with just a name and code,', '只需姓名和代码即可立即连接，', '名前とコードだけですぐにつながり、'],
  ['선명한 화상·음성, 끊김 없는 원격 제어로', 'with clear video and audio and smooth remote control,', '通过清晰的音视频和流畅的远程控制，', '鮮明な映像と音声、スムーズな遠隔操作で、'],
  ['어디서든 생산적인 협업을 경험하세요.', 'collaborate productively wherever you are.', '随时随地高效协作。', 'どこからでも効率的に協働できます。'],
  ['회의 시작하기', 'Start a meeting', '开始会议', '会議を開始する'],
  ['Windows 앱 내려받기', 'Download the Windows app', '下载 Windows 应用', 'Windowsアプリをダウンロード'],
  ['번역중', 'Translating', '正在翻译', '翻訳中'],
  ['원어', 'Original', '原文', '原文'],
  ['Connected', 'Connected', '已连接', '接続済み'],
  ['미팅룸', 'Meeting room', '会议室', '会議室'],
  ['QUIC audio-only · 참가자 1', 'QUIC audio-only · 1 participant', 'QUIC 纯音频 · 1 位参会者', 'QUIC 音声のみ · 参加者1人'],
  ['Participants', 'Participants', '参会者', '参加者'],
  ['내 자신', 'You', '你自己', '自分'],
  ['채팅', 'Chat', '聊天', 'チャット'],
  ['아직 메시지가 없습니다.', 'No messages yet.', '暂无消息。', 'メッセージはまだありません。'],
  ['메시지를 입력하세요', 'Enter a message', '输入消息', 'メッセージを入力'],
  ['마이크 끄기', 'Mute microphone', '关闭麦克风', 'マイクをオフ'],
  ['카메라 켜짐', 'Camera on', '摄像头已开启', 'カメラオン'],
  ['화면 공유', 'Share screen', '共享屏幕', '画面共有'],
  ['나가기', 'Leave', '离开', '退出'],
  ['설치 부담 없이, 이름과 코드만으로 빠르게 연결', 'Connect quickly with a name and code, without installation', '无需安装，只需姓名和代码即可快速连接', 'インストール不要、名前とコードですぐに接続'],
  ['AntsMeeting 의 강력한 기능', 'Powerful AntsMeeting features', 'AntsMeeting 的强大功能', 'AntsMeetingの充実した機能'],
  ['초저지연 연결', 'Ultra-low latency', '超低延迟连接', '超低遅延接続'],
  ['QUIC 기반 P2P 기술로 지연 없는 빠른 연결', 'Fast, low-latency connections with QUIC-based P2P', '基于 QUIC 的 P2P 技术实现快速低延迟连接', 'QUICベースのP2P技術で高速・低遅延接続'],
  ['원격 제어 최적화', 'Optimized remote control', '优化的远程控制', '最適化された遠隔操作'],
  ['부드럽고 정확한 제어로 실제 작업처럼 편리하게', 'Smooth, precise control that feels like working locally', '流畅精准的控制，如同本地操作一样便捷', '手元で作業するように滑らかで正確な操作'],
  ['고화질 화면 공유', 'High-quality screen sharing', '高清屏幕共享', '高画質の画面共有'],
  ['선명한 화질과 안정적인 화면 공유 지원', 'Clear visuals and stable screen sharing', '清晰画质与稳定的屏幕共享', '鮮明で安定した画面共有'],
  ['선명한 음성 품질', 'Clear audio', '清晰音质', 'クリアな音声'],
  ['AI 기반 노이즈 제거로 명확한 음성 전달', 'Clear speech with AI-powered noise reduction', 'AI 降噪让语音更清晰', 'AIノイズ除去で明瞭な音声を伝達'],
  ['참가자 관리', 'Participant management', '参会者管理', '参加者管理'],
  ['참가자 권한 관리 및 실시간 채팅 지원', 'Participant permissions and real-time chat', '参会者权限管理与实时聊天', '参加者の権限管理とリアルタイムチャット'],
  ['안전한 보안', 'Secure by design', '安全保障', '安心のセキュリティ'],
  ['데이터 암호화 및 권한 기반 보안 제어', 'Data encryption and permission-based security', '数据加密与基于权限的安全控制', 'データ暗号化と権限に基づくセキュリティ制御'],
  ['다양한 환경에서 활용하세요', 'Built for a range of uses', '适用于多种场景', 'さまざまな場面で活用'],
  ['원격 기술 지원', 'Remote technical support', '远程技术支持', '遠隔技術サポート'],
  ['원격으로 문제를 진단하고 신속하게 해결', 'Diagnose and resolve problems remotely', '远程诊断并快速解决问题', '問題を遠隔で診断し、迅速に解決'],
  ['온라인 교육', 'Online education', '在线教育', 'オンライン教育'],
  ['강의 자료 공유 및 실시간 상호작용 지원', 'Share course materials and interact in real time', '共享课程资料并实时互动', '教材共有とリアルタイムのやり取りに対応'],
  ['팀 협업 회의', 'Team collaboration', '团队协作会议', 'チームの共同作業'],
  ['프로젝트 공유 및 효율적인 커뮤니케이션', 'Share projects and communicate efficiently', '共享项目并高效沟通', 'プロジェクト共有と効率的なコミュニケーション'],
  ['고객 지원 · 유지보수', 'Customer support and maintenance', '客户支持与维护', '顧客サポート・保守'],
  ['고객 시스템 원격 접속 및 신속한 문제 해결', 'Access customer systems remotely and resolve issues quickly', '远程访问客户系统并快速解决问题', '顧客システムへの遠隔接続で迅速に問題解決'],
  ['간단한 3단계 사용 방법', 'Get started in three steps', '简单三步即可使用', '簡単な3ステップ'],
  ['이름 입력', 'Enter your name', '输入姓名', '名前を入力'],
  ['표시할 이름을 입력하세요. (예: 홍길동)', 'Enter the name you want to display.', '输入要显示的姓名。', '表示する名前を入力してください。'],
  ['방 만들기 또는 참여', 'Create or join a room', '创建或加入会议室', '会議室を作成・参加'],
  ['새 방을 만들거나 6자리 코드를 입력해 참여하세요.', 'Create a room or join with a six-digit code.', '创建会议室或输入六位代码加入。', '会議室を作成するか、6桁のコードで参加してください。'],
  ['바로 연결 시작', 'Connect right away', '立即开始连接', 'すぐに接続開始'],
  ['화면 공유, 원격 제어, 채팅 등 모든 기능을 바로 사용하세요.', 'Start using screen sharing, remote control and chat.', '立即使用屏幕共享、远程控制和聊天等功能。', '画面共有、遠隔操作、チャットなどをすぐに使えます。'],
  ['안정적이고 안전한 연결 기술', 'Reliable, secure connection technology', '稳定安全的连接技术', '安定した安全な接続技術'],
  ['내 PC', 'Your PC', '你的电脑', '自分のPC'],
  ['직접 연결', 'Direct connection', '直接连接', '直接接続'],
  ['상대 PC', 'Remote PC', '对方的电脑', '相手のPC'],
  ['서버를 거치지 않는 직접 연결이므로 빠르고 안정적입니다.', 'Direct connections without a server relay are fast and stable.', '无需服务器中转，直接连接更快速稳定。', 'サーバーを経由しない直接接続で高速かつ安定。'],
  ['네트워크 환경에 최적화하여 끊김을 최소화합니다.', 'Optimized for your network to reduce interruptions.', '针对网络环境优化，减少连接中断。', 'ネットワーク環境に合わせて接続の中断を最小限に。'],
  ['권한 기반 제어로 보안 걱정 없이 안심하고 사용합니다.', 'Permission-based controls help keep your work secure.', '基于权限的控制让使用更安心。', '権限に基づく制御で安心して利用できます。'],
  ['내려받기', 'Downloads', '下载', 'ダウンロード'],
  ['브라우저만 있으면 바로 시작할 수 있습니다. 원격 제어까지 쓰려면 Windows 앱을 받으세요.', 'Start in your browser. Download the Windows app for remote control.', '使用浏览器即可开始。使用远程控制请下载 Windows 应用。', 'ブラウザーですぐに開始。遠隔操作にはWindowsアプリをご利用ください。'],
  ['원격 제어 · 고화질 화면 공유 · 화상 회의 전부', 'Remote control, high-quality screen sharing and video meetings', '远程控制、高清屏幕共享与视频会议', '遠隔操作・高画質画面共有・ビデオ会議'],
  ['직접 다운로드', 'Direct download', '直接下载', '直接ダウンロード'],
  ['Microsoft Store 에서 받기', 'Get it from Microsoft Store', '从 Microsoft Store 获取', 'Microsoft Storeから入手'],
  ['브라우저', 'Browser', '浏览器', 'ブラウザー'],
  ['설치 없음 · Chrome·Edge 권장', 'No installation · Chrome or Edge recommended', '无需安装 · 推荐 Chrome 或 Edge', 'インストール不要 · Chrome・Edge推奨'],
  ['이름과 코드만 넣으면 바로 연결됩니다', 'Connect with just a name and code', '只需姓名和代码即可连接', '名前とコードだけですぐに接続'],
  ['지금 회의 시작', 'Start a meeting now', '立即开始会议', '今すぐ会議を開始'],
  ['내려받을 것이 없습니다', 'Nothing to download', '无需下载', 'ダウンロード不要'],
  ['앤츠미팅으로 협업의 새로운 경험을 시작하세요!', 'Discover a new way to collaborate with AntsMeeting!', '使用 AntsMeeting，开启全新协作体验！', 'AntsMeetingで新しい共同作業を始めましょう！'],
  ['빠르고, 안전하고, 간편한 차세대 협업 솔루션', 'Fast, secure and simple next-generation collaboration', '快速、安全、便捷的新一代协作方案', '高速・安全・簡単な次世代コラボレーション'],
  ['앤츠미팅이 여러분의 업무와 소통을 혁신합니다.', 'AntsMeeting transforms the way you work and communicate.', 'AntsMeeting 改善你的工作与沟通方式。', 'AntsMeetingが仕事とコミュニケーションを変えます。'],
  ['앤츠네스트 · AntsMeeting', 'AntsNest · AntsMeeting', 'AntsNest · AntsMeeting', 'AntsNest · AntsMeeting'],
  ['앤츠네스트 다운로드', 'AntsNest downloads', 'AntsNest 下载', 'AntsNest ダウンロード'],
  ['앤츠네스트', 'AntsNest', 'AntsNest', 'AntsNest'],
];

export const messages = Object.fromEntries(['ko', 'en', 'zh', 'ja'].map((language, index) => [language, Object.freeze(Object.fromEntries(rows.map(row => [row[0], row[index]])))]));

export function translate(language, key) {
  return Object.prototype.hasOwnProperty.call(messages[language] || {}, key) ? messages[language][key] : key;
}
